import { http } from './client';

export interface HealthCheckDto {
    name: string;
    status: 'healthy' | 'degraded' | 'down';
    description?: string;
}

export interface HealthReportDto {
    status: 'healthy' | 'degraded' | 'down';
    checks: HealthCheckDto[];
}

export const healthApi = {
    async report(): Promise<HealthReportDto> {
        try {
            const { data } = await http.get<HealthReportDto>('/health');
            return data;
        } catch (err) {
            // 503 deg/unhealthy — backend всё равно возвращает HealthReportDto в body.
            // axios считает 503 ошибкой, но сам отчёт нам нужен — извлекаем из response.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const data = (err as any)?.problem as HealthReportDto | undefined;
            if (data && data.checks) return data;
            throw err;
        }
    }
};